import { render, staticRenderFns } from "./GuideZh.vue?vue&type=template&id=0ee67da4&scoped=true&"
import script from "./GuideZh.vue?vue&type=script&lang=js&"
export * from "./GuideZh.vue?vue&type=script&lang=js&"
import style0 from "./GuideZh.vue?vue&type=style&index=0&id=0ee67da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee67da4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
